import React from 'react';
import SmartDialog from "../SmartDialog/SmartDialog";

class CommissionInfoDialog extends  React.Component{

    constructor(props){
        super(props);
        this.state = {

        };
    }

    show(){
        this._dlg.show();
    }

    render(){
        return <SmartDialog ref={r => this._dlg = r} title={<h4>Commissions</h4>} showCancelButton={true}>
            <p>Show commissions received today , this week and the for the month</p>
            </SmartDialog>;
    }

}

export default CommissionInfoDialog;


// WEBPACK FOOTER //
// ./src/components/CommisionInfoDialog/CommissionInfoDialog.js